var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 558,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.64 278.89C557.64 124.94 432.84.14 278.9.14S.14 124.94.14 278.89s124.8 278.75 278.75 278.75 278.75-124.8 278.75-278.75Z",
    fill: "#E42058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.35 254.89-132.31-.1c-36.07 0-66.07 28.52-67.01 65.19-.03.98.78 1.79 1.76 1.79l132.31.08v.02c36.07 0 66.07-28.52 67.01-65.19a1.76 1.76 0 0 0-1.76-1.79ZM420.41 154.45l-199.36-.1c-36.07 0-66.07 28.52-67.01 65.19-.03.98.78 1.79 1.76 1.79l199.36.08v.02c36.07 0 66.07-28.52 67.01-65.19a1.76 1.76 0 0 0-1.76-1.79ZM187.56 421.86a33.53 33.53 0 1 0 0-67.06 33.53 33.53 0 0 0 0 67.06Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h558v558H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlr);
export default __webpack_public_path__ + "static/media/FLR.c8db821b5ea579d6f4ce3d22da6c1f06.svg";
export { ForwardRef as ReactComponent };